import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { DELETE_MODELS } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { DeleteModelsDataActionTypes } from './types';
import modelsApi from 'src/utils/api/modelsApi';

export const loadDeleteModels =
  (
    id: string,
  ): ThunkAction<Promise<void>, State, null, DeleteModelsDataActionTypes> =>
  async (dispatch) => {
    dispatch({ type: DELETE_MODELS + REQUEST });
    try {
      const payload = await modelsApi.loadDeleteModels(id);
      dispatch({ type: DELETE_MODELS + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: DELETE_MODELS + FAILURE, error });
    }
  };

export const deleteModelssIdle = () => ({ type: DELETE_MODELS + IDLE });
